import { z } from "zod";
import type { TFunction } from "i18next";

export function createEditRequestSchema({ t, extraPayOnly = false }: { t: TFunction; extraPayOnly?: boolean }) {
    return z.object({
        type: z.enum(["open-shift", "call-off", "direct-offer"]),
        reason: extraPayOnly
            ? z.string()
            : z.string().trim().min(1, { message: t("required-reason") }),
        payType: z.enum(["fixed", "hourly"]),
        payAmount: z.union([
            z.literal(""),
            z.coerce.number({ message: t("invalid-amount") }).positive({ message: t("invalid-amount") }),
        ]).optional(),
    });
}

export type EditRequestFormValues = z.infer<ReturnType<typeof createEditRequestSchema>>;
